import { render } from "./WomensShoes.vue?vue&type=template&id=64c0d894"
import script from "./WomensShoes.vue?vue&type=script&lang=js"
export * from "./WomensShoes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__